import React from 'react'
import {
  List, Datagrid, TextField
} from 'admin-on-rest'

export const RoleList = (props) => (
  <List {...props} title='Papéis'>
    <Datagrid>
      <TextField label='Nome' source='name' />
      <TextField label='Descrição' source='description' />
    </Datagrid>
  </List>
)



// WEBPACK FOOTER //
// ./src/collections/roles.js